"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showPageWithContext = exports.showPage = exports.setShowPage = exports.reducePageState = exports.initialState = exports.hidePage = exports.getShowPageWithContext = exports.getShowPage = exports.default = void 0;
var _toolkit = require("@reduxjs/toolkit");
const initialState = exports.initialState = {
  showPage: false,
  context: {}
};
const setShowPage = exports.setShowPage = (0, _toolkit.createAction)("SHOW_PAGE");
const showPage = exports.showPage = setShowPage(true);
const showPageWithContext = function (context) {
  return setShowPage({
    showPage: true,
    context
  });
};
exports.showPageWithContext = showPageWithContext;
const hidePage = exports.hidePage = setShowPage({
  showPage: false,
  context: {}
});
const reducePageState = function (state, _ref) {
  let {
    payload
  } = _ref;
  if (typeof payload.context === "object") {
    state.showPage = payload.showPage;
    state.context = payload.context || {};
  } else {
    state.showPage = payload;
  }
};
exports.reducePageState = reducePageState;
const getShowPage = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return state === null || state === void 0 ? void 0 : state.showPage;
};
exports.getShowPage = getShowPage;
const getShowPageWithContext = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return state;
};
exports.getShowPageWithContext = getShowPageWithContext;
var _default = exports.default = (0, _toolkit.createReducer)(initialState, {
  [setShowPage]: reducePageState
});